import { storageManager } from '@authFlow/utils/SessionStorageManager';

export const isMainInputUserWithDomain = () => {
  const userData = storageManager.get('userData');
  const src = storageManager.get('src');

  return src === 'main_cta' && !!userData?.domain;
};

export const getMainInputValue = (): string => {
  const redirectTo = storageManager.get('redirectTo');
  const query = redirectTo.split('?')[1];
  const searchParams = new URLSearchParams(query);

  return searchParams
    ? searchParams.get('domain') || searchParams.get('q')
    : null;
};

export const getMainInputUserData = () => {
  const src = storageManager.get('src');
  const redirectTo = storageManager.get('redirectTo');

  if (!(src === 'main_cta' && redirectTo)) {
    return null;
  }

  const mainInputValue = getMainInputValue();

  if (!mainInputValue) {
    return null;
  }

  const domainRegExp = new RegExp('^\\S+\\.\\S{2,}$', 'ig');
  const mainInputUserType = domainRegExp.test(mainInputValue)
    ? 'domain'
    : 'keyword';

  return { [mainInputUserType]: getMainInputValue() };
};
